import { ShieldCheck, Lock, CreditCard } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { SITE } from "@/lib/site";

export default function Billing() {
  return (
    <>
      <Seo
        title="Update Billing Information | CYAN Wireless"
        description="Securely update the billing and payment information on your CYAN Wireless account. Locally owned rural internet in Cortez, Dolores, Yellow Jacket & Lewis, Colorado."
        path="/update"
      />
      <section className="relative pt-40 pb-24 sm:pt-48 bg-ink-950 overflow-hidden min-h-screen">
        <div className="absolute top-24 -right-40 w-[500px] h-[500px] rounded-full bg-cyan-500/10 blur-[140px]" />
        <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <p className="overline mb-6 flex items-center gap-3"><span className="w-8 h-px bg-cyan-500" />Account &amp; Billing</p>
            <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-white leading-[0.9]">
              Update your<br /><span className="text-aurora">billing info.</span>
            </h1>
            <p className="mt-6 text-lg text-zinc-400 max-w-md">
              Use this form to securely update the payment information on your CYAN Wireless account. Once we receive it, we'll update your account and confirm.
            </p>

            <ul className="mt-8 space-y-4">
              <li className="flex items-center gap-3 text-white"><span className="w-8 h-8 grid place-items-center rounded-full bg-cyan-500/15 text-cyan-400"><Lock size={16} /></span>Submitted directly to CYAN — never shared.</li>
              <li className="flex items-center gap-3 text-white"><span className="w-8 h-8 grid place-items-center rounded-full bg-cyan-500/15 text-cyan-400"><ShieldCheck size={16} /></span>We only keep the last 4 digits on file.</li>
              <li className="flex items-center gap-3 text-white"><span className="w-8 h-8 grid place-items-center rounded-full bg-cyan-500/15 text-cyan-400"><CreditCard size={16} /></span>Questions? Call us at {SITE.phone}.</li>
            </ul>
          </Reveal>

          <Reveal delay={0.1} className="bg-ink-900 border border-white/10 rounded-2xl p-8">
            <div className="flex items-center gap-2 mb-2 text-cyan-400">
              <Lock size={16} /><span className="font-mono-tech text-xs uppercase tracking-widest">Secure Update</span>
            </div>
            <h2 className="font-display font-bold text-2xl text-white mb-2">Update account information</h2>
            <p className="text-zinc-400 text-sm mb-6">Please provide your details and new card information.</p>
            <LeadForm type="billing" submitLabel="Submit Securely" showAddress showBilling />
          </Reveal>
        </div>
      </section>
    </>
  );
}
